import { environment } from 'src/environments/environment'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Form, FormGroup } from '@angular/forms'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { AccessRights } from '../../role/user-role/user-role'
import { ConfigurationOptionService } from '../configuration-option.service'
import { ISO639LanguageCodes } from 'src/app/shared/utils/languageCodes'
import { Observable, of } from 'rxjs'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { documentActions } from '../../document/document.actions'
import { Document, DocumentType } from '../../document/document'
import { v4 as uuidv4 } from 'uuid'
import { catchError, take, timeout } from 'rxjs/operators'
import { RolePermission } from '../../role/role-permission/role-permission'

@UntilDestroy()
@Component({
  selector: 'shop-tiles-form',
  templateUrl: './shop-tiles-form.component.html',
  styleUrls: ['./shop-tiles-form.component.scss']
})
export class ShopTilesFormComponent implements OnInit {
  @Input() form: FormGroup
  @Input() tile: any
  @Input() rolePermissions$: Observable<RolePermission[]>

  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  public ISO639LanguageCodes = Object.values(ISO639LanguageCodes).filter(
    (language) => this.availableLanguages[language]
  )
  public selectedLanguage$: Observable<string>
  public langSelected: ISO639LanguageCodes = ISO639LanguageCodes.English

  public config: any = {
    placeholder: '',
    tabsize: 2,
    dialogsInBody: true,
    height: '200px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
      'opensans',
      'sansserif',
      'monospace',
      'serif'
    ]
  }
  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private actions$: Actions,
    private configOptionService: ConfigurationOptionService,
    public accessRightService: UserAccessRightService
  ) {}

  ngOnInit(): void {
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.selectedLanguage$
      .pipe(untilDestroyed(this))
      .subscribe((lang) => (this.langSelected = lang as ISO639LanguageCodes))
  }

  public setLanguageSelected(language: string) {
    this.langSelected = language as ISO639LanguageCodes
  }
  public getImageUrl(imagePath: string) {
    return `${environment.staticAssetBaseUrl}${imagePath}`
  }

  public onSubmitImage(file: File) {
    this.store.dispatch(
      documentActions.createOneWithFile({
        entity: {
          type: DocumentType.BRANDING_IMAGE,
          isPublic: true,
          path: `branding/${uuidv4()}`
        },
        file
      })
    )

    this.actions$
      .pipe(
        ofType(documentActions.upsertMany),
        take(1),
        timeout(5000),
        catchError((error) => of(null))
      )
      .subscribe((action) => {
        if (!action) {
          return this.notificationService.emit('alerts.warning', 'error')
        }
        const document: Document = action.entities[0]
        this.form.controls.imagePath.patchValue(document.path)
        this.notificationService.emit('alerts.success', 'success')
      })
  }
}
